import React from "react";
import "./home.css";

const Home = () => {
  return (
    <div className="Home">
      <div className="lander">
        <h1>VLibrary</h1>
        <p className="text-muted">A simple virtual library app</p>
      </div>
    </div>
  );
};

export default Home;
